import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/healthrecords/'
const ITEM_ID  = 'hea_id'

export const useHealthrecordStore = defineStore('healthrecords', {
  //storage option
  persist: true,
  // convert to a function
  state: () => ({
    item: { hea_sta_id: 'GEN01', hea_typ_id: 'HEA01', hea_typ_id_dose: 'HED01', hea_typ_id_way: 'HAD01', hea_customfields: {} },
    itemList: []
  }),
  getters: {

  },
  actions: {
    fetchItem (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id > 0 ){
                ApiService.get(ENDPOINT + id + options).then( (response) => {
                    if( !response.data.data.hea_customfields || Object.prototype.toString.call( response.data.data.hea_customfields ) === '[object Array]' ) {
                        response.data.data.hea_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItems (options) {
        return new Promise( (resolve, reject) => {
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.metaTask = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.SET_ITEMS(response.data.data)
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    storeItem () {
        return new Promise( (resolve, reject) => {
            ApiService.post( ENDPOINT, this.item ).then( (response) => {
            this.SET_ITEM(response.data.data)
            resolve(this.item)
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    updateItem () {
        return new Promise( (resolve, reject) => {
            ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
            this.SET_ITEM(response.data)
            resolve(this.item)
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    destroyItem (id) {
        return new Promise( (resolve, reject) => {
            this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
            ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
                this.RESET_ITEM()
            resolve('resolved')
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
    },
    SET_ITEMS (itemList) {
      this.itemList = itemList
    },
    RESET_ITEM () {
        this.item = { 
            hea_lst_id: null,
            hea_sta_id: 'GEN01',
            hea_typ_id: 'HEA01',
            hea_treatment_date: '',
            hea_product: '',
            hea_product_id: '',
            hea_dose: null,
            hea_typ_id_dose: 'HED01',
            hea_typ_id_way: 'HAD01',
            hea_waiting_period: null,
            hea_label: '',
            hea_order: '',
            hea_usr_id: null,
            hea_customfields : {}
        }
    }
  }
})
